<template>
  <div>
    <div class="relative">
      <div v-if="activeIndex !== null">
        <img :src="activeImage" alt="" />
      </div>
      <div
        @click="handleLeft"
        class="absolute transform p-2 left-0 border-green border bg-white bg-opacity-25 cursor-pointer top-50
        hover:bg-opacity-50
        text-green rounded"
      >
        <svg
          class="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          ></path>
        </svg>
      </div>
      <div
        @click="handleRight"
        class="absolute transform p-2 right-0 border-green border bg-white bg-opacity-25 cursor-pointer top-50
        hover:bg-opacity-50
        text-green rounded"
      >
        <svg
          class="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 5l7 7-7 7"
          ></path>
        </svg>
      </div>
      <div class="absolute bottom-0 transform text-center w-full">
        <span
          v-for="(img, index) in images"
          :key="index"
          @click="select(index)"
          class="w-2 h-2  cursor-pointer inline-block bg-white rounded-full ml-2 transform hover:scale-105 border
          border-green"
        ></span>
      </div>
    </div>
<!--    <div class="grid grid-cols-5 gap-2 mt-2">-->
<!--      <div class="bg-black" v-for="(img, index) in images" :key="index" @click="select(index)">-->
<!--        <div class="relative pb-100 overflow-hidden">-->
<!--          <img :src="img" class="absolute object-center w-full cursor-pointer" />-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  name: "SimpleGallery",
  props: {
    images: {
      type: Array
    }
  },
  data() {
    return {
      activeIndex: null,
      maxIndex: null
    };
  },
  computed: {
    activeImage() {
      return this.images[this.activeIndex];
    }
  },
  mounted() {
    this.activeIndex = 0;
    this.maxIndex = this.images.length - 1;
  },
  methods: {
    handleLeft() {
      this.activeIndex = Math.max(this.activeIndex - 1, 0);
    },
    handleRight() {
      this.activeIndex = Math.min(this.activeIndex + 1, this.maxIndex);
    },
    select(index) {
      this.activeIndex = index;
    }
  }
};
</script>

<style scoped>
.pb-100 {
  padding-bottom: 100%;
}
.top-50 {
  top: 50%;
}
.right-50 {
  left: 50%;
}
</style>
